// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3fUvK","footer":"ModalError_footer__3oedi"};